/**
 * Language toggle button (BUILD_SPEC.md §14.4).
 *
 * Renders the *target* locale's name — clicking "EN" while in Arabic
 * switches to English, and vice versa. Two characters fit in the
 * compact header without crowding.
 */

import { useTranslation } from "react-i18next";
import { useLangStore } from "@/stores/langStore";

interface Props {
  size?: "sm" | "md";
}

export function LangToggle({ size = "md" }: Props) {
  const { t } = useTranslation();
  const locale = useLangStore((s) => s.locale);
  const toggle = useLangStore((s) => s.toggle);

  const targetLabel = locale === "ar" ? "EN" : "ع";
  const tooltip = `${t("common.language")}: ${locale === "ar" ? "English" : "العربية"}`;
  const text = size === "sm" ? "text-sm" : "text-base";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={tooltip}
      title={tooltip}
      className={`rounded-md px-2.5 py-1.5 font-semibold ${text} text-fg dark:text-fg-dark hover:bg-hairline/40 dark:hover:bg-hairline-dark/40 transition-colors`}
    >
      {targetLabel}
    </button>
  );
}
